import React from 'react';
import ReactDOM from 'react-dom/client';
import headerProps from './staticHeaderData.json';
import { SearchSite } from '../../../utils/setupHeaderAndFooter';
import { Log, LogWarning } from '../../../utils/logging';
import UdirHeader, { HeaderData } from './UdirHeader';

/**
 * @deprecated Bruker FE-pakkens globale window.UdirComponents.Header som har
 * dobbel-svg-bug på menu-button og menu-link. Behold mens vi tester den nye
 * implementasjonen (mountHeaderNew).
 */
export function mountHeaderLegacy(site: SearchSite, headerProperties?: any) {
    let components = (window as any).UdirComponents;
    const headerData = headerProperties ? headerProperties : headerProps;
    headerData["breadcrumbs"] = getBreadCrumbs(site);
    if(site === SearchSite.Global) {
        Log(headerData);
    }
    console.log(headerData);
    (window as any).ReactDOM.render((window as any).React.createElement(components.Header, headerData), document.getElementById('header'))
}

let cachedRoot: ReactDOM.Root | null = null;

/**
 * Ny header basert på @udir-design/react/beta. Mounter UdirHeader til #header.
 */
export function mountHeaderNew(site: SearchSite, headerProperties?: any) {
    const data: HeaderData = headerProperties ? headerProperties : (headerProps as any);
    data.breadcrumbs = getBreadCrumbs(site) as any;
    const container = document.getElementById('header');
    if (!container) {
        Log('No #header container found, skipping header mount');
        return;
    }
    if (!cachedRoot) {
        cachedRoot = ReactDOM.createRoot(container);
    }
    cachedRoot.render(React.createElement(UdirHeader, { data }));
}

/**
 * Mounter det globale varselbanneret (alertBlock) fra FE-pakka inn i
 * #global-alert. Bruker window.UdirComponents.AlertBlock som finnes i
 * search-dist >= 2026-06-02_3581. No-op hvis alertBlock-data mangler,
 * containeren ikke finnes, eller FE-pakka ikke eksponerer AlertBlock.
 */
export function mountAlertBlock(alertBlock?: any) {
    if (!alertBlock) return;
    const container = document.getElementById('global-alert');
    if (!container) return;
    const components = (window as any).UdirComponents;
    if (!components || !components.AlertBlock) {
        LogWarning('window.UdirComponents.AlertBlock ikke tilgjengelig — sjekk at search-dist er 2026-06-02_3581 eller nyere');
        return;
    }
    (window as any).ReactDOM.render(
        (window as any).React.createElement(components.AlertBlock, alertBlock),
        container
    );
}

// Default-eksport peker på den nye implementasjonen.
//export default mountHeaderNew;
export default mountHeaderLegacy;

function getBreadCrumbs(site: SearchSite) {
    let baseUrl = "https://www.udir.no";
    if(window.location.host === "localhost:3000"){
        baseUrl = "https://integration.udir.no";
    }else if(window.location.host === "udir-sok-utv.azurewebsites.net"){
        baseUrl = "https://integration.udir.no"
    }else if(window.location.host === "qa-sokeresultat.udir.no"){
        baseUrl = "https://preprod.udir.no"
    }

    if(site === SearchSite.LPV) {
        return JSON.parse('{"items":[{"href":"'+baseUrl+'","isSelected":false,"text":"Forside"},{"href":"'+baseUrl+'/laring-og-trivsel/","isSelected":false,"text":"Læring og trivsel"},{"href":"'+baseUrl+'/laring-og-trivsel/lareplanverket/","isSelected":false,"text":"Læreplanverket"},{"isSelected":true,"text":"Søk i læreplaner"}],"label":"Brødsmulesti ","languageTag":"nb","title":"Du er her:"}');
    } else if (site === SearchSite.FoR) {
        return JSON.parse('{"items":[{"href":"https://www.udir.no/","isSelected":false,"text":"Forside"},{"href":"https://www.udir.no/tall-og-forskning/","isSelected":false,"text":"Tall og forskning"},{"href":"","isSelected":true,"text":"Søk i forskning og statistikk"}],"label":"Brødsmulesti","languageTag":"nb","title":"Du er her:"}');
    } else if (site === SearchSite.Eksamensoppgaver) {
        return JSON.parse('{"items":[{"href":"https://www.udir.no/","isSelected":false,"text":"Forside"},{"href":"https://www.udir.no/eksamen-og-prover/","isSelected":false,"text":"Eksamen og prøver"},{"href":"https://www.udir.no/eksamen-og-prover/eksamen/","isSelected":false,"text":"Eksamen"},{"isSelected":true,"text":"Søk i eksamensoppgaver"}],"label":"Brødsmulesti","languageTag":"nb","title":"Du er her:"}');
    } else if(site === SearchSite.Global) {
        return JSON.parse('{"items":[{"href":"https://www.udir.no/","isSelected":false,"text":"Forside"},{"isSelected":true,"text":"Søk på udir.no"}],"label":"Brødsmulesti","languageTag":"nb","title":"Du er her:"}');
    } else if(site === SearchSite.Regelverk) {
        return JSON.parse('{"items":[{"href":"https://www.udir.no/","isSelected":false,"text":"Forside"},{"href":"https://www.udir.no/regelverk-og-tilsyn/","isSelected":false,"text":"Regelverk og tilsyn"},{"href":"","isSelected":true,"text":"Søk i regelverk"}],"label":"Brødsmulesti","languageTag":"nb","title":"Du er her:"}');
    }else {
        return {}
    }
}


